import { Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { QueryParam } from "../../../../../utils/constants";
import SmallEntityTypeCardGauge from "../../components/EntityTypeGauge/SmallEntityTypeCardGauge";
import { getPluralizedTitle } from "../../utils";
import { EntityTypeInfo } from "../constants";

export default function SmallEntityTypeCard({ entityType, metadata }) {
  const colors = useColors();
  const { trackEvent } = useAPI();
  const [searchParams, setSearchParams] = useSearchParams();

  const entityTypeInfo = EntityTypeInfo[entityType];
  const cardInfo = [
    {
      color: colors.error_light_label_text,
      quantity: metadata.at_risk,
      tooltipText: `${metadata.at_risk} ${getPluralizedTitle(
        entityTypeInfo.title,
        metadata.total_entities
      )} at risk`,
    },
    {
      color: colors.success_soft_label_text,
      quantity: metadata.are_protected,
      tooltipText: `${metadata.are_protected} ${getPluralizedTitle(
        entityTypeInfo.title,
        metadata.total_entities
      )} protected`,
    },
  ];
  const coverage = (metadata.are_protected / metadata.total_entities) * 100;
  const isTypeCurrentlyViewed =
    entityType === searchParams.get(QueryParam.environmentType);

  return (
    <Box
      minWidth="210px"
      height="130px"
      display="flex"
      sx={{
        borderRadius: "25px",
        boxShadow: isTypeCurrentlyViewed
          ? colors.selected_entity_type_card_box_shadow
          : colors.entity_type_card_box_shadow,
        padding: "16px",
        cursor: "pointer",
      }}
      onClick={() => {
        trackEvent(
          `User clicked "${entityType}" small entity type card to view the entities`
        );
        const params = new URLSearchParams({
          [QueryParam.environmentType]: entityType,
        });
        setSearchParams(params);
      }}
    >
      <Box
        width="124px"
        height="98px"
        display="flex"
        flexDirection="column"
        gap={1}
      >
        <Box width="32px" height="32px">
          <SvgToIcon
            IconLogo={entityTypeInfo.icon}
            width="100%"
            height="100%"
          />
        </Box>
        <Box display="flex" alignItems="top" height="32px" gap={0.5}>
          <Typography variant="overline">{metadata.total_entities}</Typography>
          <Box>
            <Typography
              component="span"
              variant="caption"
              color={colors.text_primary}
              style={{
                paddingTop: "1px",
                lineHeight: 1.4,
                display: "block",
              }}
            >
              {getPluralizedTitle(
                entityTypeInfo.title,
                metadata.total_entities
              )}
            </Typography>
          </Box>
        </Box>
        <Box display="flex">
          <Box display="flex" gap={0}>
            {cardInfo.map((item, index) => (
              <CustomToolTip
                title={item.tooltipText}
                placement="top"
                key={index}
              >
                <Box
                  display="flex"
                  height="18px"
                  alignItems="center"
                  gap={0.5}
                  padding="0 12px 0 0"
                >
                  <Box
                    sx={{
                      backgroundColor: item.color,
                      width: "8px",
                      height: "8px",
                      borderRadius: "50%",
                    }}
                  />
                  <Typography variant="caption" color={colors.grey_700}>
                    {item.quantity}
                  </Typography>
                </Box>
              </CustomToolTip>
            ))}
          </Box>
        </Box>
      </Box>
      <Box position="relative">
        <Box position="absolute" top={-10}>
          <SmallEntityTypeCardGauge value={coverage} />
        </Box>
      </Box>
    </Box>
  );
}
